// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { categoryCardStyles } from "@steiner/App/Components/Category/CategoryCard";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

categoryCardStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    `,
};

categoryCardStyles.imageClickable = {};

categoryCardStyles.image = {
    width: "148px",
    height: "148px",
    css: css`
        ${xScreen("lte", "xs")} {
            height: 156px;
            width: 156px;
        }
        img {
            aspect-ratio: 1 / 1;
        }
    `,
};

categoryCardStyles.link = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.semiBold,
        lineHeight: "19px",
        css: css`
            text-align: center;
            ${ellipsis(3)}
        `,
    },
    css: css`
        align-self: center;
    `,
};
